module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/yellow@2x.png?04850a24";